/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SettlementMethod = {
    NotSpecified: 'NotSpecified',
    FlexSettled: 'FlexSettled',
    Profiled: 'Profiled',
    NonProfiled: 'NonProfiled',
} as const;
export type SettlementMethod = typeof SettlementMethod[keyof typeof SettlementMethod];

